// components/FastBookingWidget.jsx
import React, { useEffect } from "react";

const FastBookingWidget = () => {
  useEffect(() => {
    // إضافة الـ script الخاص بالبيانات
    const configScript = document.createElement("script");
    configScript.className = "fb-widget-config";
    configScript.type = "application/json";
    configScript.setAttribute("data-fbConfig", "0");
    configScript.text = JSON.stringify({
      params: [
        {
          calendar: {
            firstDayOfWeek: 1,
            nbMonths2display: 2,
            title: "BOOK A ROOM",
            showBestPrice: true,
            showLastRoom: true,
            showLastRoomThreshold: 5,
            showMinStayDepartureDates: false,
            showChildrenAges: true,
            openBookingFunnel: true,
            themeDark: false,
            layoutNum: 1,
            roomRateFiltering: 0,
            rateFilter: [],
            roomFilter: [],
            useLoyalty: false,
            loyalty: "",
            loyaltyParams: {},
            maxLengthStay: 0,
            maxInfantAge: 2,
            maxChildrenAge: 12,
            disableUnavailableDateSelection: false,
          },
          hotelInfos: {
            cityName: "",
            countryCode: "",
            guests: {
              adult: {
                attributes: {
                  minimumAge: 12,
                  maximumAge: 130,
                  maximumCount: 2,
                },
              },
              children: {
                attributes: { minimumAge: 2, maximumAge: 12, maximumCount: 2 },
              },
              infants: {
                attributes: { minimumAge: 0, maximumAge: 2, maximumCount: 2 },
              },
            },
            id: 0,
            maxLengthStay: 0,
            name: "",
            rating: 0,
            referenceRateCode: "",
            timeZone: "",
          },
          currency: "USD",
          locale: "en_GB",
          pricesDisplayMode: "normal",
          offerComputeRule: "lowerMinstay",
          maxAdults: 3,
          maxChildren: 2,
          mainColor: "#b0a06c",
          themeDark: false,
          openFrontInNewTab: true,
          property: "egale22046",
          title: "Borg El Arab Resort",
          childrenMaxAge: 12,
          groupsNames: "",
          quicksearch: { showChildrenAges: true },
          fbWidget: "Calendar",
        },
      ],
      hotelInfos: null,
      commonParams: {
        redirectUrl:
          "https://redirect.fastbooking.com/DIRECTORY/dispoprice.phtml",
        showPropertiesList: false,
        demoMode: false,
        allowGroupSelection: false,
        groupName: "",
      },
      _authCode:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzY29wZXMiOiIuKiIsInByb3BlcnRpZXMiOiJlZ2FsZTIyMDQ2IiwiZ3JvdXBzIjoiXiQiLCJmb3IiOiJCYWNrb2ZmaWNlIiwiaWF0IjoxNzUwMDY4NzYxLCJqaWQiOiI2ODRmZDFmOTAyNThhIn0.CcuwKGpqGJutTBYOOfUN0HpW5OXWanHG_5zQNcOLCDk",
      propertyIndex: 0,
      version: "1.68.1",
      baseHost: "websdk.fastbooking-services.com",
    });

    document.body.appendChild(configScript);

    // تحميل CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "//websdk.fastbooking-services.com/widgets/app.css";
    document.head.appendChild(link);

    // تحميل سكربت FastBooking
    const script = document.createElement("script");
    script.src = "//websdk.fastbooking-services.com/widgets/app.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // تنظيف بعد الخروج من المكون
      document.body.removeChild(configScript);
      document.body.removeChild(script);
      document.head.removeChild(link);
    };
  }, []);

  return <div id="fb-widget-1" className="fb-widget" data-fbConfig="0"></div>;
};

export default FastBookingWidget;
